import type { z } from "zod";

/** Maps Zod issues to the RFC 7807 `errors` shape: field → array of messages. */
export function zodToFieldErrors(error: z.ZodError): Record<string, string[]> {
  const fieldErrors: Record<string, string[]> = {};
  for (const issue of error.issues) {
    const path = issue.path.length > 0 ? issue.path.join(".") : "_root";
    if (!fieldErrors[path]) {
      fieldErrors[path] = [];
    }
    fieldErrors[path].push(issue.message);
  }
  return fieldErrors;
}

/** Convenience: returns first error message per field for simple form UI. */
export function firstFieldErrors(
  errors: Record<string, string[]>,
): Record<string, string> {
  const result: Record<string, string> = {};
  for (const [field, messages] of Object.entries(errors)) {
    if (messages.length > 0) {
      result[field] = messages[0];
    }
  }
  return result;
}
